import { useState } from 'react';
// import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const json = await res.json();
      setStatus(json.success ? 'sent' : 'error');
      if (json.success) setForm({ name: '', email: '', phone: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24 px-6 max-w-[1280px] mx-auto">
        <div className="mb-16 text-center md:text-left">
          <span className="inline-block py-1 px-4 rounded-full bg-[#8fb3ff]/20 text-[#174388] text-sm mb-4">CONNECT WITH US</span>
          <h1 className="text-5xl font-bold text-[#00255a] mb-6">Talk to a Study Abroad and Scholarship Expert</h1>
          <p className="text-lg text-[#44474f] max-w-2xl">
            Whether you are looking for scholarships to study abroad, international university admissions or a career opportunity overseas, our team can guide your next step.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Form */}
          <section className="lg:col-span-7 bg-white p-8 md:p-12 rounded-2xl border border-[#e2e8f0] shadow-[0px_10px_30px_rgba(30,60,114,0.05)]">
            <h2 className="text-2xl font-bold text-[#00255a] mb-8">Ask About Scholarships, Courses or Visas</h2>

            {status === 'sent' ? (
              <div className="text-center py-12">
                <span className="material-symbols-outlined text-6xl text-green-600 mb-4">check_circle</span>
                <h3 className="text-xl font-bold text-[#00255a] mb-2">Message Sent!</h3>
                <p className="text-[#64748b]">We'll get back to you as soon as possible.</p>
              </div>
            ) : (
              <form className="space-y-6" onSubmit={handleSubmit}>
                {status === 'error' && (
                  <div className="p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">
                    Something went wrong. Please try again or contact us via WhatsApp.
                  </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Field label="Full Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} placeholder="John Doe" required />
                  <Field label="Email Address" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} placeholder="john@example.com" required />
                </div>
                <Field label="Phone Number" type="tel" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} placeholder="+263 77 000 0000" />
                <div>
                  <label className="block text-sm font-semibold text-[#44474f] mb-2">Your Message</label>
                  <textarea
                    rows="5"
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    placeholder="Tell us your preferred course, destination and scholarship goals..."
                    required
                    className="w-full px-4 py-3 rounded-lg border border-[#c4c6d1] bg-[#f7f9fb] focus:border-[#00255a] focus:ring-2 focus:ring-[#00255a]/10 outline-none transition-all resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className="w-full text-white font-semibold py-4 rounded-lg shadow-lg hover:scale-[1.02] transition-all flex items-center justify-center gap-2 disabled:opacity-60"
                  style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
                >
                  {status === 'sending' ? 'Sending...' : 'Send Your Study Abroad Inquiry'}
                  <span className="material-symbols-outlined">send</span>
                </button>
              </form>
            )}
          </section>

          {/* Contact Info Stack */}
          <aside className="lg:col-span-5 space-y-6">
            <div className="bg-white p-6 rounded-2xl border border-[#e2e8f0] shadow-sm">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl bg-[#00255a]/5 flex items-center justify-center text-[#00255a]">
                  <span className="material-symbols-outlined">location_on</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#00255a]">Head Office</h3>
                  <p className="text-[#64748b] mt-1">Alasco Building, 11th Avenue and R Mugabe</p>
                </div>
              </div>
              <a
                href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3745.379451589431!2d28.583293374955936!3d-20.159920481280874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1eb5547360919575%3A0x867602192aeac6fa!2sRobert%20Mugabe%20Way%20%26%2011th%20Avenue%2C%20Bulawayo%2C%20Zimbabwe!5e0!3m2!1sen!2sin!4v1785952997706!5m2!1sen!2sin"
                target="_blank"
                rel="noreferrer"
                className="w-full h-40 rounded-lg overflow-hidden bg-[#eceef0] mt-4 relative flex items-center justify-center group"
              >
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3745.379451589431!2d28.583293374955936!3d-20.159920481280874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1eb5547360919575%3A0x867602192aeac6fa!2sRobert%20Mugabe%20Way%20%26%2011th%20Avenue%2C%20Bulawayo%2C%20Zimbabwe!5e0!3m2!1sen!2sin!4v1785952997706!5m2!1sen!2sin" width="600" height="450" className="border-0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                <span className="material-symbols-outlined text-5xl text-[#c4c6d1] group-hover:text-[#00255a] transition-colors">map</span>
                <span className="absolute bottom-2 right-2 bg-white px-3 py-1 rounded shadow text-sm text-[#00255a] font-bold">Open Maps</span>
              </a>
            </div>

            <div className="bg-white rounded-2xl border border-[#e2e8f0] shadow-sm overflow-hidden">
              <a href="https://wa.me/263775827371" target="_blank" rel="noreferrer" className="flex items-center gap-4 p-5 hover:bg-[#f2f4f6] transition-colors border-b border-[#e2e8f0]">
                <div className="w-10 h-10 rounded-full bg-[#25D366]/10 flex items-center justify-center text-[#25D366]">
                  <span className="material-symbols-outlined">chat</span>
                </div>
                <div className="flex-1">
                  <p className="text-sm text-[#64748b]">WhatsApp Support</p>
                  <p className="font-semibold text-[#00255a]">+263 77 582 7371</p>
                </div>
                <span className="material-symbols-outlined text-[#c4c6d1]">chevron_right</span>
              </a>
              <a href="mailto:agentzw@iascupdate.com" className="flex items-center gap-4 p-5 hover:bg-[#f2f4f6] transition-colors border-b border-[#e2e8f0]">
                <div className="w-10 h-10 rounded-full bg-[#00255a]/10 flex items-center justify-center text-[#00255a]">
                  <span className="material-symbols-outlined">mail</span>
                </div>
                <div className="flex-1">
                  <p className="text-sm text-[#64748b]">Official Email</p>
                  <p className="font-semibold text-[#00255a]">agentzw@iascupdate.com</p>
                </div>
                <span className="material-symbols-outlined text-[#c4c6d1]">chevron_right</span>
              </a>
              <a href="https://instagram.com/iasc_consultancy" target="_blank" rel="noreferrer" className="flex items-center gap-4 p-5 hover:bg-[#f2f4f6] transition-colors">
                <div className="w-10 h-10 rounded-full bg-[#E4405F]/10 flex items-center justify-center text-[#E4405F]">
                  <span className="material-symbols-outlined">camera</span>
                </div>
                <div className="flex-1">
                  <p className="text-sm text-[#64748b]">Instagram</p>
                  <p className="font-semibold text-[#00255a]">@iasc_consultancy</p>
                </div>
                <span className="material-symbols-outlined text-[#c4c6d1]">chevron_right</span>
              </a>
            </div>

            {/* PLACEHOLDER — office hours not yet confirmed by client */}
            <div className="bg-[#00255a] text-white p-6 rounded-2xl shadow-sm relative overflow-hidden">
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <span className="material-symbols-outlined text-[#aec6ff]">schedule</span>
                  <h3 className="text-lg font-bold">Operational Hours</h3>
                </div>
                <div className="space-y-3 opacity-90 text-sm">
                  <div className="flex justify-between border-b border-white/20 pb-3">
                    <span>Mon — Fri</span>
                    <span className="font-bold">08:00 — 17:00</span>
                  </div>
                  <div className="flex justify-between opacity-60">
                    <span>Weekends</span>
                    <span className="italic">By appointment</span>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

function Field({ label, value, onChange, type = 'text', placeholder, required }) {
  return (
    <div>
      <label className="block text-sm font-semibold text-[#44474f] mb-2">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        className="w-full px-4 py-3 rounded-lg border border-[#c4c6d1] bg-[#f7f9fb] focus:border-[#00255a] focus:ring-2 focus:ring-[#00255a]/10 outline-none transition-all"
      />
    </div>
  );
}
